import React from 'react';
import { motion } from 'framer-motion';
import { Coffee, Users, Heart, Calendar, Sparkles } from 'lucide-react';
const TEAM_IMG = 'https://cdn.magicpatterns.com/uploads/nwaFokr74juteZS55uN5r6/IMG_1797.jpg';
const STOREFRONT_IMG = 'https://cdn.magicpatterns.com/uploads/cc2y4qUjqX45emSk5qKPA8/Captura_de_pantalla_2026-05-15_a_las_17.17.27.png';
const CELEBRATION_IMG = 'https://cdn.magicpatterns.com/uploads/cRGTjDus1xK2i89D6LovXw/IMG_1802.jpg';
const TSHIRT_IMG = 'https://cdn.magicpatterns.com/uploads/9Ciq6qbcTAuMNVVzQ9YWEE/IMG_1817.jpg';
export function Sobre() {
  return <div className="py-12 md:py-20" data-id="element-403">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-404">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-405">
          <motion.span initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} className="text-cafe-accent text-sm tracking-[0.3em] uppercase font-medium" data-id="element-406">
            Nuestra historia
          </motion.span>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl font-serif text-cafe-primary mt-3 mb-6" data-id="element-407">
            Sobre Nosotros
          </motion.h1>
          <div className="w-24 h-px bg-cafe-accent mx-auto" data-id="element-408" />
        </div>
        {/* Storefront image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative rounded-3xl overflow-hidden shadow-soft mb-16 aspect-[16/9]" data-id="element-409">
          <img src={STOREFRONT_IMG} alt="Exterior de Trastienda Café" className="w-full h-full object-cover" data-id="element-410" />
          <div className="absolute inset-0 bg-gradient-to-t from-cafe-primary/60 via-transparent to-transparent" data-id="element-411" />
          <div className="absolute bottom-6 left-6 md:bottom-8 md:left-8 text-white" data-id="element-412">
            <div className="flex items-center gap-2 text-sm tracking-widest uppercase mb-2" data-id="element-413">
              <Calendar size={14} data-id="element-414" />
              Est. 2021
            </div>
            <p className="font-serif text-xl md:text-2xl italic" data-id="element-415">
              Tu rincón de barrio
            </p>
          </div>
        </motion.div>
        {/* Story text */}
        <motion.section initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-cafe-text/80 text-center mb-24" data-id="element-416">
          <p className="text-xl md:text-2xl font-serif italic text-cafe-primary mb-8 leading-relaxed" data-id="element-417">
            "Trastienda Café nace en 2021 con la vocación de ser ese lugar
            especial donde el tiempo se detiene."
          </p>
          <p className="text-lg leading-relaxed mb-4" data-id="element-418">
            Somos un café de barrio, un espacio diseñado para ser acogedor,
            cercano y familiar. Creemos en las cosas hechas con cariño y sin
            prisas.
          </p>
          <p className="text-lg leading-relaxed" data-id="element-419">
            Nuestro objetivo es ofrecer un rincón tranquilo donde puedas
            disfrutar de una buena conversación, leer un libro o simplemente
            relajarte mientras degustas nuestras especialidades, desde nuestros
            churros artesanos hasta nuestros cafés cuidadosamente preparados.
          </p>
        </motion.section>
        {/* Team image with text */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16 items-center mb-24" data-id="element-420">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="rounded-3xl overflow-hidden shadow-soft aspect-[4/5]" data-id="element-421">
            <img src={TEAM_IMG} alt="Equipo de Trastienda Café bajo el cartel del local" className="w-full h-full object-cover" data-id="element-422" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} data-id="element-423">
            <span className="text-cafe-accent text-sm tracking-[0.3em] uppercase font-medium" data-id="element-424">
              Las personas
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-cafe-primary mt-3 mb-6" data-id="element-425">
              Detrás de cada taza
            </h2>
            <p className="text-cafe-text/80 text-lg leading-relaxed mb-4" data-id="element-426">
              Trastienda Café es, sobre todo, un proyecto humano. Detrás de cada
              crepe, cada tosta y cada café hay personas que ponen cariño en lo
              que hacen.
            </p>
            <p className="text-cafe-text/80 text-lg leading-relaxed" data-id="element-427">
              Te recibimos como nos gusta que nos reciban a nosotros: con una
              sonrisa, un buen café y todo el tiempo del mundo.
            </p>
          </motion.div>
        </div>
        {/* Momentos especiales — celebración */}
        <div className="bg-cafe-card rounded-3xl overflow-hidden mb-24" data-id="element-428">
          <div className="grid grid-cols-1 md:grid-cols-2 items-stretch" data-id="element-429">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} className="p-10 md:p-14 flex flex-col justify-center" data-id="element-430">
              <div className="flex items-center gap-2 text-cafe-accent text-sm tracking-[0.3em] uppercase font-medium mb-4" data-id="element-431">
                <Sparkles size={14} data-id="element-432" />
                Momentos especiales
              </div>
              <h2 className="text-3xl md:text-4xl font-serif text-cafe-primary mb-6 leading-tight" data-id="element-433">
                Aquí celebramos
                <br data-id="element-434" />
                <span className="italic" data-id="element-435">la vida juntos</span>
              </h2>
              <p className="text-cafe-text/80 text-lg leading-relaxed mb-4" data-id="element-436">
                Cumpleaños, reuniones de amigos, encuentros familiares...
                Trastienda Café es ese sitio en el que los buenos momentos
                tienen mejor sabor.
              </p>
              <p className="text-cafe-text/80 text-lg leading-relaxed" data-id="element-437">
                Y a veces es nuestro barrio el que nos celebra a nosotros — un
                reconocimiento que nos llena de cariño y nos impulsa a seguir
                con la misma ilusión del primer día.
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} className="aspect-square md:aspect-auto md:min-h-[500px] overflow-hidden" data-id="element-438">
              <img src={CELEBRATION_IMG} alt="Equipo de Trastienda Café recogiendo un reconocimiento en el Palacio de Congresos de Marbella" className="w-full h-full object-cover" data-id="element-439" />
            </motion.div>
          </div>
        </div>
        {/* Branding moment — camiseta */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16 items-center mb-24" data-id="element-440">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} data-id="element-441">
            <span className="text-cafe-accent text-sm tracking-[0.3em] uppercase font-medium" data-id="element-442">
              Nuestra marca
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-cafe-primary mt-3 mb-6" data-id="element-443">
              Mucho más que un café
            </h2>
            <p className="text-cafe-text/80 text-lg leading-relaxed mb-4" data-id="element-444">
              Cada miembro del equipo lleva nuestro nombre con orgullo. La
              camiseta de Trastienda es el símbolo de un proyecto cuidado, donde
              cada detalle —desde la cocina hasta la atención— tiene una
              identidad propia.
            </p>
            <p className="text-cafe-text/80 text-lg leading-relaxed" data-id="element-445">
              Ven a conocernos. Te recibirá un equipo que cree en lo que hace.
            </p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="rounded-3xl overflow-hidden shadow-soft aspect-[4/5] order-first md:order-last" data-id="element-446">
            <img src={TSHIRT_IMG} alt="Equipo de Trastienda Café trabajando detrás de la barra con sus camisetas oficiales" className="w-full h-full object-cover" data-id="element-447" />
          </motion.div>
        </div>
        {/* Values */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-8 border-t border-cafe-border" data-id="element-448">
          {[{
          icon: Coffee,
          title: 'Artesanía',
          text: 'Nuestros churros, crepes y batidos son elaborados al momento, cuidando cada detalle.'
        }, {
          icon: Users,
          title: 'Cercanía',
          text: 'Un trato amable y familiar. Queremos que te sientas como en casa cada vez que nos visitas.'
        }, {
          icon: Heart,
          title: 'Compromiso',
          text: 'Comprometidos con causas que importan. Apoyamos activamente a la Fundación FEEP.'
        }].map((v, i) => <motion.div key={v.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="text-center p-8 bg-white rounded-2xl shadow-soft border border-cafe-border/50" data-id="element-449">
              <div className="w-16 h-16 mx-auto bg-cafe-card rounded-full flex items-center justify-center mb-4" data-id="element-450">
                <v.icon className="text-cafe-accent" size={28} data-id="element-451" />
              </div>
              <h3 className="text-xl font-serif text-cafe-primary mb-3" data-id="element-452">
                {v.title}
              </h3>
              <p className="text-cafe-text/70 text-sm leading-relaxed" data-id="element-453">
                {v.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </div>;
}